import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_FileSelect = _resolveComponent("FileSelect")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Space = _resolveComponent("Space")!
  const _component_Card = _resolveComponent("Card")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_Space, {
            vertical: "",
            xlarge: "",
            full: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Fieldset, { label: "ファイル" }, {
                default: _withCtx(() => [
                  _createVNode(_component_FileSelect, {
                    type: "img",
                    name: "ファイルを選ぶ",
                    onLoad: _cache[0] || (_cache[0] = ($event: any) => (_ctx.conf.img = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Image),
                      _createTextVNode(" ファイルを選ぶ ")
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_Fieldset, { label: "前処理" }, {
                default: _withCtx(() => [
                  _createVNode(_component_Select, {
                    modelValue: _ctx.conf.filter,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.conf.filter) = $event)),
                    name: "前処理",
                    nullable: "",
                    options: _ctx.FILTER_OPTIONS
                  }, null, 8 /* PROPS */, ["modelValue", "options"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}